import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ConfirmationPage = () => {
  const location = useLocation();
  const message = location.state.message;

  return (
    <div className="container mt-4">
      <div className="row">
        <p>{message}</p>
        <div className="col-2">
          <button className="btnRounded mt-2 w-100">
            <Link to="/booking-details">OK</Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
